var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.$style.saying_screen}},[_c('div',{class:_vm.$style.caption},[_c('div',{class:_vm.$style.full},[_vm._v(_vm._s(_vm.item.full))]),_c('div',{class:_vm.$style.link},[_vm._v(_vm._s(_vm.item.link))])])])}
var staticRenderFns = []

export { render, staticRenderFns }